import Vue from 'vue'
import axios from 'axios'
import router from '@/router';

const bodybuilder = require('bodybuilder')
const { Client } = require('elasticsearch')
const cdchabitat_es_client = Client({ host: process.env.VUE_APP_ES_BASE_URL, httpAuth: `${process.env.VUE_APP_ES_USER}:${process.env.VUE_APP_ES_PASSWORD}` })
const CDCH_AUTH_INDEX = "cdc_habitat_auth";

var SHA1 = require("crypto-js/sha1");

const state = {
    token: localStorage.getItem('user-token') || '',
    status: '',
    hasLoadedOnce: false,
    connexion_error: '',
    redirect_route: '',
    is_authenticated : false,
    token_loading :false,
    last_action : null,
    logout_message :''
}

const getters = {
    token: state => state.token,
    is_authenticated : state => state.is_authenticated,
    // is_authenticated: state => !!state.token,
    auth_status: state => state.status,
    connexion_error: state => state.connexion_error,
    redirect_route: state => state.redirect_route,
    token_loading : state => state.token_loading,
    logout_message : state => state.logout_message
}

const actions = {
    async checktoken({commit, dispatch}){
        let is_authenticated = false;

        try{
            dispatch("set_token_loading_on");

            const response = await axios.get(process.env.VUE_APP_API_BASE_URL + 'Auth/Utilisateur/CheckToken');
            
            // Checktoken from back
            if ((response && response.data.httpStatusCode == 200 && response.data.content)) {
                let tokenObj =  response.data.content.token != null ? response.data.content.token : null;
                let tokenDateStr = tokenObj.generated.split(' ')[0];
                let tokenDateStrNormalize = ''
                tokenDateStrNormalize = tokenDateStrNormalize.concat(tokenDateStr.split('/')[2],tokenDateStr.split('/')[1],tokenDateStr.split('/')[0]);

                let todday = new Date();
                let day = todday.getDate()
                let dayStr = '00'.concat(day).slice(-2)
                let month = ''
                month = month.concat('0',todday.getMonth()+1);
                month =  month.substr(month.length-2)
                let year = todday.getFullYear()
                let toddayStrNormalize = ''
                toddayStrNormalize = toddayStrNormalize.concat(year,month,dayStr )

                //Check token is produced todday ?
                if(tokenDateStrNormalize == toddayStrNormalize ){
                    is_authenticated=true; 
                }else{
                    dispatch('set_message_logout',process.env.VUE_APP_MESSAGE_LOGOUT)
                }
                
                //Check token is used less then 45min else timeout
                let generatedTokenDateTimeSTR = tokenObj.generated
                let tYear = tokenObj.generated.split(' ')[0].split('/')[2];
                let tMonth =parseInt(tokenObj.generated.split(' ')[0].split('/')[1],10)-1;
                let tDay =tokenObj.generated.split(' ')[0].split('/')[0];
                let tHour =tokenObj.generated.split(' ')[1].split(':')[0];
                let tMin =tokenObj.generated.split(' ')[1].split(':')[1];
                let tSec =tokenObj.generated.split(' ')[1].split(':')[2];

                let generatedTokenDateTimeDATE = new Date();
                generatedTokenDateTimeDATE.setFullYear(tYear);
                generatedTokenDateTimeDATE.setMonth(tMonth);
                generatedTokenDateTimeDATE.setDate(tDay);
                generatedTokenDateTimeDATE.setHours(tHour);
                generatedTokenDateTimeDATE.setMinutes(tMin);
                generatedTokenDateTimeDATE.setSeconds(tSec);
              

                let refdate =  state.last_action !=null ? state.last_action : generatedTokenDateTimeDATE
                let current_action = new Date()
                let inactivity_secs = (current_action - refdate)/(1000)
                let timeout = parseInt(process.env.VUE_APP_TIME_OUT,10)
    
                if(inactivity_secs > timeout ){
                    is_authenticated=false;
                    dispatch('set_message_logout',process.env.VUE_APP_MESSAGE_LOGOUT_INACTIVITY)
                } 

            }else{
                is_authenticated=false;
            }
        }catch(error){
            console.log('error occured : ', error)
            is_authenticated = false;
        }finally{
            dispatch("set_token_loading_off");

            if(is_authenticated){
                //commit('SET_LAST_ACTION');
                dispatch('set_last_action')
            }
            //commit("SET_AUTHENTICATED", is_authenticated);
            dispatch('set_authenticated',is_authenticated)
        } 
    },

    async check_activity({commit, dispatch}){
        console.log('check_activity!')
        let is_authenticated = true;
        try{
            let refdate =  state.last_action
            let current_action = new Date()
            let inactivity_secs = (current_action - refdate)/(1000)
            let timeout = parseInt(process.env.VUE_APP_TIME_OUT,10)
           
            if(inactivity_secs > timeout ){
                is_authenticated=false; 
                dispatch('set_message_logout',process.env.VUE_APP_MESSAGE_LOGOUT_INACTIVITY)
            }
            console.log('inactivity_secs : ',inactivity_secs)

        }catch(error){
            //console.log('error occured : ', error)
            is_authenticated = false;
        }finally{
            //commit("SET_AUTHENTICATED", is_authenticated);
            dispatch('set_authenticated',is_authenticated)
        }
        
    },
    async auth_request({commit, dispatch}, user) {
        // user must have email & password set
        if (!(user && user.email && user.email.length && user.password && user.password.length)) {
            console.error("invalid user data");
            return
        }
        // 1 - call API to check if user.email && user.password match
        try {

            const response = await axios.post(process.env.VUE_APP_API_BASE_URL + 'Auth/Utilisateur/LoginFrontoffice', user);
            const token = response.data.content.token.value;
            const tokenGenerated = response.data.content.token.generated;

            // console.log('auth response', response)
            // 2 - if success, authenticate the user and save info in localstorage
            let user_data = null;
            
            if (response && response.status === 200 && token) {
                commit("AUTH_SUCCESS", { token: token });
                localStorage.setItem('user-token', token);

                // GET USER DETAILS
                user_data = response.data.content.entity;
                delete user_data.password;
                
                // dispatch('load_projects_by_type', { mode: 'home' });
                dispatch('set_user_profile', { user: user_data });

                //Set last action (use to timeout)
                dispatch('set_last_action')

                // if user tried to access another route (stored in redirect_route), let's go there
                if (state.redirect_route && state.redirect_route.length > 0) {
                    router.push(state.redirect_route);
                } else {
                    router.push('/');
                }
            } else {
                dispatch("set_token_loading_off");
                throw "Wrong email/password combination";
            }
        } catch (error) {
        // 3 - if not, refuse to log in
            console.error("Authentication failed:", error);
            commit('AUTH_ERROR');
            dispatch("auth_logout");
        }
    },

    auth_logout({commit, dispatch}) {
        commit("SET_AUTHENTICATED", false);
        dispatch("set_token_loading_off");
        dispatch('remove_user_profile');
        localStorage.removeItem('user-token');
        commit("AUTH_LOGOUT")
        router.push('/login');
    },

    reset_connexion_error( {commit}) {
        commit('RESET_CONNEXION_ERROR');
    },

    set_redirect_route( { commit }, data ) {
        if (data && data.redirect_route) {
            commit('SET_REDIRECT_ROUTE', data);
        }
    },
    set_authenticated( {commit},data) {
        commit('SET_AUTHENTICATED',data);
    },
    set_token_loading_on( {commit}) {
        commit('SET_TOKEN_LOADING_ON');
    },
    set_token_loading_off( {commit}) {
        commit('SET_TOKEN_LOADING_OFF');
    },
    set_last_action( {commit}) {
        commit('SET_LAST_ACTION');
    },
    set_message_logout( {commit},data) {
        commit('SET_MESSAGE_LOGOUT',data);
    }
}

const mutations = {
    AUTH_REQUEST(state, data) {
        state.status = 'loading'
    },
    AUTH_SUCCESS(state, data) {
        state.status = 'success'
        state.token = data.token
        state.hasLoadedOnce = true
    },
    AUTH_ERROR(state, data) {
        state.status = 'error'
        state.connexion_error = 'Connexion invalide, veuillez réessayer'
        state.hasLoadedOnce = true        
    },
    AUTH_LOGOUT(state, data) {
        state.token = ''        
    },
    RESET_CONNEXION_ERROR(state, data) {
        Vue.set(state, 'connexion_error', '');
        // state.connexion_error = '';
    },
    SET_REDIRECT_ROUTE(state, data) {
        Vue.set(state, 'redirect_route', data.redirect_route);
    },
    SET_AUTHENTICATED(state, data) {
        state.is_authenticated = data
    },
    SET_TOKEN_LOADING_ON(state, data) {
        state.token_loading = true
    },
    SET_TOKEN_LOADING_OFF(state, data) {
        state.token_loading = false
    },
    SET_LAST_ACTION(state, data) {
        state.last_action = new Date()
    },
    SET_MESSAGE_LOGOUT(state, data) {
        state.logout_message = data
    },
    
    

}

export default { state, getters, actions, mutations }